<template>
  <div id="app" :key="i18nKey">
    <Header></Header>
    <router-view />
  </div>
</template>
<script>
import Header from "./views/home/Header";

import axios from 'axios'
import { mapGetters, mapActions } from "vuex";
import { I18N_URL } from "./constants";

export default {
  name: "App",
  components: {
    Header,
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  watch: {
    // 监听国际化语种字段，有更新且不为空时重新获取国际化数据，同时更新缓存中的国际化数据
    lang: {
      handler(val, nval) {
        if (val && val !== nval) {
          this.getI18nData(val);
        }
      },
      // 初始化的时候执行
      immediate: false,
    },
  },
  data() {
    return {
      i18nKey:"i18nKey",
      langList: [
        {
          label: "英语",
          local: "English",
          value: "EN"
        },
        {
          label: "中文",
          local: "中文",
          value: "CN"
        }
      ]
    };
  },
  created() {
    this.initI18nData();
  },
  methods: {
    ...mapActions([
      "SET_LANG",
      "SET_LANG_JSON",
      "SET_DEFAULT_LANG",
      "SET_LANG_LIST",
    ]),
    // 初始化系统国际化数据
    async initI18nData() {
      // 语言列表
      this.getLangList();
      // 获取本地语言信息
      let lan = localStorage.getItem("lang");
      // 本地语种存在
      if (lan) {
        // 更新store中默认语言
        this.SET_DEFAULT_LANG(lan);
      } else {
        // 获取数据库的默认语种信息
        lan = await this.getDefaultLang();
      }
      // 获取国际化数据
      lan && this.getI18nData(lan);
    },

    //  获取默认语言
    async getDefaultLang() {
      try {
        const { data: { code, msg, data = "" } = {} } = await axios.get(
          `${I18N_URL}/i18n/dictionary/getDefaultLang`
        );
        if (code === 1 && data) {
          // 更新store中的系统当前语言
          this.SET_LANG(data);
          // 更新store中默认语言
          return this.SET_DEFAULT_LANG(data);
        } else {
          console.error(msg);
        }
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
    // 获取语言列表
    async getLangList() {
      try {
        // 更新store中语言列表
        this.SET_LANG_LIST(this.langList);
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
    // 获取国际化数据
    async getI18nData(lang) {
      try {
        const { data: { code, msg, data } = {} } = await axios.get(
          `${I18N_URL}/i18n/sysInternational/getSysInternationalList`,
          {
            params: {},
            headers: {
              langType: lang,
            },
          }
        );
        if (code === 1) {
          // 更新store中国国际化数据
          this.SET_LANG_JSON(data).then(() => {
            // 更新路由key，保证页面内的界面重载更新语言数据
            this.i18nKey = new Date().getTime();
            console.log(this.i18nKey);
          });
        } else {
          console.error("getI18nData::fail", msg);
        }
      } catch (error) {
        console.error("getI18nData::error", error);
      }
    },
  },
};
</script>
<style lang="scss">
@import "./assets/iconfont/iconfont.css";
#app {
  height: 100%;
}
$bg: rgba(0, 0, 0, 0.1);
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条小方块*/
::-webkit-scrollbar-thumb {
  background-color: #b2b2b2;
  -webkit-border-radius: 5px; /* Safari 和 Chrome */
  -moz-border-radius: 5px; /* Firefox */
  -o-border-radius: 5px; /* Opera */
  border-radius: 5px;
}
/*滚动轨道两端按钮*/
::-webkit-scrollbar-button {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
/*滚动轨道 内阴影*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
</style>
